




























































































































































































































































import {Component, Mixins, Prop} from 'vue-property-decorator';
import {ShoppingCartUploadResultType} from '@/entities/shopping-cart-upload/ShoppingCartUploadResultType';
import BaseMixin from '@/mixins/BaseMixin';
import Price from '@/components/price/Price.vue';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import {ShoppingCartUploadResultItem} from '../../../entities/shopping-cart-upload/ShoppingCartUploadResultItem';
import {ShoppingCartUploadModuleTypes} from '@/store/modules/shopping-cart-upload';
import {ShoppingCartUploadInfo} from '@/entities/shopping-cart-upload/ShoppingCartUploadInfo';
import {LoadingIndicator} from '@/components/loading-indicator/LoadingIndicator.tsx';
import _ from 'lodash';

@Component({
    components: {
        DeliveryTimeToolTip,
        Price,
        LoadingIndicator,
    },
})
export default class ShoppingCartUploadResultTable extends Mixins(BaseMixin) {
    @Prop({type: String, required: true})
    private resultType!: ShoppingCartUploadResultType;

    private ResultTypes: typeof ShoppingCartUploadResultType = ShoppingCartUploadResultType;

    private updateQuantityAndReloadAvailabilityDebounced: (
        partId: string,
        type: ShoppingCartUploadResultType,
        quantity: number
    ) => void;

    constructor() {
        super();
        this.updateQuantityAndReloadAvailabilityDebounced = _.debounce(this.updateQuantityAndReloadAvailability, 500);
    }

    public get resultItems(): ShoppingCartUploadResultItem[] {
        switch (this.resultType) {
            case ShoppingCartUploadResultType.Found:
                return (this.$store.getters[ShoppingCartUploadModuleTypes.getters.uploadInfo] as ShoppingCartUploadInfo)
                    .result.foundParts;
            case ShoppingCartUploadResultType.Replacement:
                return (this.$store.getters[ShoppingCartUploadModuleTypes.getters.uploadInfo] as ShoppingCartUploadInfo)
                    .result.replacementParts;
            case ShoppingCartUploadResultType.Used:
                return (this.$store.getters[ShoppingCartUploadModuleTypes.getters.uploadInfo] as ShoppingCartUploadInfo)
                    .result.usedParts;
            default:
                return (this.$store.getters[ShoppingCartUploadModuleTypes.getters.uploadInfo] as ShoppingCartUploadInfo)
                    .result.notFoundParts;
        }
    }

    private get columnSizeForInfoText(): number {
        switch (this.resultType) {
            case ShoppingCartUploadResultType.Found:
                return 1;
            case ShoppingCartUploadResultType.NotFound:
                return 8;
            default:
                return 1;
        }
    }

    private get columnSizeForDescription(): number {
        if (this.resultType === ShoppingCartUploadResultType.Replacement) {
            return 1;
        }

        return 2;
    }

    private get columnSizeForQuantity(): number {
        if (this.resultType === ShoppingCartUploadResultType.Used) {
            return 2;
        }

        return 1;
    }

    private isLoadingAvailability(partId: string): boolean {
        return (
            this.$store.getters[ShoppingCartUploadModuleTypes.getters.itemsThatAreLoadingAvailability] as string[]
        ).includes(partId);
    }

    private itemClicked(event: any, partId?: string): void {
        if (!partId) {
            return;
        }

        const checkbox = event.target as HTMLInputElement;
        if (checkbox && checkbox.checked) {
            this.$store.commit(ShoppingCartUploadModuleTypes.mutations.selectPartWithId, {partId});
        } else {
            this.$store.commit(ShoppingCartUploadModuleTypes.mutations.deselectPartWithId, {partId});
        }
    }

    private getAvailableItemCount(item: ShoppingCartUploadResultItem): number {
        if (!item.partAvailability || !item.partAvailability.stockInfos) {
            return 0;
        }
        return item.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }

    private quantityChangedForPart(partId: string, type: ShoppingCartUploadResultType, quantity: number): void {
        if (quantity > 0) {
            this.updateQuantityAndReloadAvailabilityDebounced(partId, type, quantity);
        }
    }

    private updateQuantityAndReloadAvailability(
        partId: string,
        type: ShoppingCartUploadResultType,
        quantity: number
    ): void {
        this.$store.dispatch(ShoppingCartUploadModuleTypes.actions.updateQuantityOfShoppingCartUploadItem, {
            partId,
            quantity,
        });
        this.$store.dispatch(ShoppingCartUploadModuleTypes.actions.reloadAvailabilityOfShoppingCartUploadItem, {
            partId,
            quantity,
            type,
        });
    }
}
